import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ListItemText, Menu, Button, MenuItem } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ShopToolbar = ({ actions }) => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleClick}>
        {t('More actions')}
        <ExpandMoreIcon />
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {actions
          .filter(({ hidden }) => !hidden)
          .map(({ name, action }) => (
            <MenuItem key={name}>
              <ListItemText primary={name} onClick={action} />
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

ShopToolbar.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      hidden: PropTypes.bool,
    }),
  ).isRequired,
};

export { ShopToolbar };
